<template>
  <div id="invoicingSet">
    <div class="invoicingHead" style="height: 110px">
      <div class="row">
        <el-button
          size="small"
          style="width: 100px"
          type="primary"
          @click="jumpTT('/invoicing/addGoodsPurchase')"
          >新增进货单</el-button
        >
        <div class="row" style>
          <el-input
            size="small"
            style="margin-left: 10px"
            placeholder="单号/仓库名称"
            v-model="synthesisSearch"
          ></el-input>
          <el-button size="small" style="margin-left: 10px" @click="search" type="primary"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="searchGroup alignCenter">
        <el-select
          size="small"
          v-model="synthesisOrderType"
          placeholder="排序"
          @change="synthesisOrderTypeChange"
        >
          <el-option
            v-for="item in synthesisOrderTypeList"
            :key="item.name"
            :label="item.value"
            :value="item.name"
          ></el-option>
        </el-select>
        <el-date-picker
          class="ml10"
          v-model="dataTime"
          :clearable="false"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dataTimeChoose"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <!-- <el-select size="small" v-model="repositoryId" placeholder="请选择入库仓库" class="ml10">
          <el-option v-for="item in repositoryList" :key="item.repositoryId" :label="item.repositoryName" :value="item.repositoryId"></el-option>
        </el-select> -->
        <el-select
          size="small"
          v-model="shopWorkerUserId"
          placeholder="经手人"
          class="ml10"
        >
          <el-option
            v-for="item in handlerList"
            :key="item.shopWorkerUserId"
            :label="item.fullName"
            :value="item.shopWorkerUserId"
          ></el-option>
        </el-select>
        <el-select size="small" v-model="supplierId" placeholder="供应商" class="ml10">
          <el-option
            v-for="item in supplierList"
            :key="item.supplierId"
            :label="item.supplierName"
            :value="item.supplierId"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          v-model="inStorageStatus"
          placeholder="入库状态"
          class="ml10"
        >
          <el-option
            v-for="item in inStorageStatusList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select size="small" v-model="isDestroy" placeholder="显示作废" class="ml10">
          <el-option
            v-for="item in isDestroyList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          size="small"
          style="margin-left: 10px"
          @click="clearSearch"
          type="primary"
          >清除</el-button
        >
        <el-button size="small" style="margin-left: 10px" @click="search" type="primary"
          >完成</el-button
        >
      </div>
    </div>
    <div class="content">
      <!-- 表格 -->
      <div>
        <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.3)"
          element-loading-text="数据正在加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            align="center"
            prop="goodsName"
            label="进货商品"
            width="180"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="repositoryName"
            label="入库仓库"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="supplierName"
            label="供应商"
          ></el-table-column>
          <el-table-column align="center" prop="orderCode" label="单号"></el-table-column>
          <el-table-column align="center" prop="accountPayable" label="金额">
            <template slot-scope="scope"> ￥{{ scope.row.accountPayable }} </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="业务日期"
          ></el-table-column>
          <el-table-column align="center" prop="inStorageStatus" label="状态">
            <template slot-scope="scope">
              <div
                v-if="scope.row.inStorageStatus == 0"
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #afafaf;
                  margin: auto;
                  color: #afafaf;
                  font-size: 10px;
                "
              >
                未入库
              </div>
              <div
                v-if="scope.row.inStorageStatus == 1"
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #fdb99e;
                  margin: auto;
                  color: #fdb99e;
                  font-size: 10px;
                "
              >
                入库
              </div>
              <div
                v-if="scope.row.inStorageStatus == 2"
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #6abcf8;
                  margin: auto;
                  color: #6abcf8;
                  font-size: 10px;
                "
              >
                部分入库
              </div>
              <div
                v-if="scope.row.inStorageStatus == 3"
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #ccc;
                  margin: auto;
                  color: #ccc;
                  font-size: 10px;
                "
              >
                作废
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button class="button5" @click="detail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div
          v-if="tableData.length > 0"
          class="block"
          style="float: right; margin-top: 10px"
        >
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pageVal"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="totalNumber"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  goodsPurchaseList,
  goodsPurchaseListTotalNum,
  supplierList,
  supplierClassificationList,
  supplierListTotal,
  repositoryList,
  Shop_handlerList,
} from "../api";
export default {
  data() {
    return {
      // 表格
      tableData: [],
      //排序下拉框数组
      options: [{ name: 1 }],
      synthesisSearch: "", //搜索框
      pageVal: 1, //分页页码
      totalNumber: null, //分页总条数
      status: "",
      synthesisOrderType: "",
      synthesisOrderTypeList: [
        { name: "", value: "全部排序" },
        { name: 0, value: "业务日期" },
        { name: 1, value: "单号" },
        { name: 2, value: "供应商名称" },
        { name: 3, value: "金额" },
      ],
      dataTime: "",
      inStorageStatus: "",
      inStorageStatusList: [
        { value: "", name: "全部" },
        { value: 0, name: "未入库" },
        { value: 1, name: "入库" },
        { value: 2, name: "部分入库" },
      ],
      isDestroyList: [
        { value: "", name: "显示作废" },
        { value: 0, name: "显示" },
        { value: 1, name: "不显示" },
      ],
      isDestroy: "",
      repositoryId: "",
      repositoryList: [],
      shopWorkerUserId: "",
      handlerList: [],
      supplierId: "",
      supplierList: [],
      loading: false,
    };
  },
  created() {
    this.goodsPurchaseList();
    this.getRepositoryList();
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    //详情
    detail(arr) {
      console.log(arr, "arr");
      // arr = JSON.stringify(arr);
      this.$router.push({
        path: "/invoicing/goodsPurchaseDetail",
        query: { type: "edit", orderId: arr.orderId, isDestroy: arr.isDestroy },
      });
      localStorage.setItem("orderId", arr.orderId);
      localStorage.setItem("isDestroy", arr.isDestroy);
    },
    clearSearch() {
      this.synthesisSearch = "";
      this.synthesisOrderType = "";
      this.startDate = "";
      this.endDate = "";
      this.dataTime = "";
      this.repositoryId = "";
      this.shopWorkerUserId = "";
      this.inStorageStatus = "";
      this.isDestroy = "";
      this.pageVal = 1;
      this.supplierId = "";
      this.goodsPurchaseList();
    },
    search() {
      this.status = 1;
      this.pageVal = 1;
      this.goodsPurchaseList(
        this.synthesisSearch.trim(),
        this.synthesisOrderType,
        this.startDate,
        this.endDate,
        this.repositoryId,
        this.shopWorkerUserId,
        this.inStorageStatus,
        this.isDestroy,
        this.supplierId
      );
    },
    //分页当前页
    handleCurrentChange(val) {
      this.pageVal = val;
      if ((this.status = 1)) {
        this.goodsPurchaseList(
          this.synthesisSearch.trim(),
          this.synthesisOrderType,
          this.startDate,
          this.endDate,
          this.repositoryId,
          this.shopWorkerUserId,
          this.inStorageStatus,
          this.isDestroy,
          this.supplierId
        );
      } else {
        this.goodsPurchaseList();
      }
    },
    //进货单列表
    goodsPurchaseList(
      synthesisSearch,
      synthesisOrderType,
      startDate,
      endDate,
      repositoryId,
      handlerId,
      inStorageStatus,
      isDestroy,
      supplierId
    ) {
      this.loading = true;
      goodsPurchaseList({
        pageNo: this.pageVal,
        row: 10,
        synthesisSearch: synthesisSearch,
        synthesisOrderType: synthesisOrderType,
        startDate: startDate,
        endDate: endDate,
        repositoryId: repositoryId,
        handlerId: handlerId,
        inStorageStatus: inStorageStatus,
        isDestroy: isDestroy,
        supplierId: supplierId,
      })
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.tableData = res.data;
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].productJson.length >= 1) {
                this.str = this.tableData[i].productJson
                  .map((item) => item.goodsName)
                  .join(",");
                this.tableData[i].goodsName = this.str;
              }
              if (this.tableData[i].isDestroy == 1) {
                this.tableData[i].inStorageStatus = 3;
              }
            }
          } else if (res.code == -1) {
            this.tableData = [];
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log("error");
        });
      goodsPurchaseListTotalNum({
        synthesisSearch: synthesisSearch,
        synthesisOrderType: synthesisOrderType,
        startDate: startDate,
        endDate: endDate,
        repositoryId: repositoryId,
        handlerId: handlerId,
        inStorageStatus: inStorageStatus,
        isDestroy: isDestroy,
        supplierId: supplierId,
      })
        .then((res) => {
          if (res.code == 1) {
            this.totalNumber = res.data.totalNum;
            console.log(this.tableData, "进货单列表条数");
          } else if (res.code == -1) {
            this.tableData = [];
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log("error");
        });
    },
    // 选择业务时期
    dataTimeChoose() {
      this.startDate = this.dataTime[0];
      this.endDate = this.dataTime[1];
    },
    synthesisOrderTypeChange(val) {
      this.goodsPurchaseList(
        this.synthesisSearch.trim(),
        this.synthesisOrderType,
        this.startDate,
        this.endDate,
        this.repositoryId,
        this.shopWorkerUserId,
        this.inStorageStatus,
        this.isDestroy,
        this.supplierId
      );
    },
    // 仓库
    getRepositoryList() {
      repositoryList({
        isManager: 1,
        isNeedAll: 1,
        pageNo: 1,
        row: 9999,
        shopStoreId: this.shopStoreId,
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.repositoryList = res.data;
          this.repositoryList.unshift({ repositoryName: "入库仓库", repositoryId: "" });
          this.Shop_handlerList();
        }
      });
    },
    // 经手人列表
    Shop_handlerList() {
      Shop_handlerList({
        isManager: 1,
        pageNo: 1,
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          this.handlerList = res.data[0].workers;
          this.handlerList.unshift({ fullName: "全部经手人", shopWorkerUserId: "" });
          this.getSupplierList();
        }
      });
    },
    // 获取供应商列表
    getSupplierList() {
      supplierList({
        isManager: 1,
        pageNo: 1,
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          this.supplierList = res.data;
          this.supplierList.unshift({ supplierName: "全部供应商", supplierId: "" });
        }
      });
    },
  },
};
</script>
<style scoped>
.commodityHead {
  box-sizing: border-box;
  width: calc(100vw - 200px);
  padding: 15px 20px 15px 30px;
  background: #f8f8f8;
  height: 160px;
  padding-top: 65px;
  position: fixed;
  z-index: 99;
}
.content {
  position: absolute;
  top: 160px;
  width: calc(100vw - 217px);
  box-sizing: border-box;
  padding: 25px;
}
.searchGroup {
  margin-top: 10px;
}
.searchGroup .el-select {
  width: 180px;
}
.ml10 {
  margin-left: 10px;
}
</style>
<style>
/* .el-input__inner {
  height: 32px;
  line-height: 32px;
} */
</style>
